import { render } from "./PublicNews.vue?vue&type=template&id=1191d58f&scoped=true"
import script from "./PublicNews.vue?vue&type=script&lang=js"
export * from "./PublicNews.vue?vue&type=script&lang=js"

import "./PublicNews.vue?vue&type=style&index=0&id=1191d58f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1191d58f"]])

export default __exports__